module.exports = __webpack_public_path__ + "img/t-test.84cd16cd.png";